<mat-dialog-content>
  <div class="container h-100">
    <h5 class="modal-title">{{ 'CASES.single.request_account_unlocking.heading' | translate }}</h5>
    <div class="row h-100">
      <div class="col-12" *ngIf="form">
        <app-server-response [response]="serverResponse"></app-server-response>
        <form [formGroup]="form" class="row mt-1">
          <div class="col-12">
            <app-input type="email" formControlName="bank_manager_email" [showClear]="false"
                       [label]="'AUTH.email' | translate" [fullWidth]="true">
            </app-input>
          </div>
        </form>
      </div>
    <!-- FOOTER -->
      <div class="col-12 mt-3 modal-footer">
        <button type="button" mat-stroked-button color="primary" class="me-3 button-outlined-primary"
                (click)="onNoClick()">{{ "SHARED.close" | translate }}
        </button>
        <button *ngIf="!isLoading && form"
                type="submit" mat-raised-button class="primary-button"
                (click)="submitAction()">
          {{ 'SHARED.submit' | translate }}
        </button>
        <div class="d-flex justify-content-center" *ngIf="isLoading" style="width: 131px; margin: 0">
          <mat-spinner diameter="30"></mat-spinner>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
